import styled from "styled-components";

export const StyledBubbleHeader = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const StyledIconWrapper = styled.div<{ $primary?: string }>`
  position: relative;
  flex-shrink: 0;
  border-radius: 50%;
  background: ${({ $primary }) => $primary};
  width: 1.25rem;
  height: 1.25rem;
  padding: 0.5rem;

  .anticon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 105%;
    height: 105%;
  }

  svg {
    width: 100%;
    height: 100%;
    color: ${({ $primary }) => $primary};
  }
`;

export const AvatarBadge = styled.span<{ $primary?: string }>`
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #ffffff;
  color: ${({ $primary }) => $primary || '#14A88E'};
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.28);

  svg {
    width: 10px;
    height: 10px;
  }
`;

export const StyledSenderName = styled.span`
  font-size: 0.813rem;
  font-weight: 700;
  color: rgb(26, 28, 30)
  line-height: 1.25;
  color: var(--text-color);
  opacity: 0.7;
`;

export const StyledBadge = styled.div<{ $primary?: string }>`
  display: inline-flex;
  align-items: center;
  margin-left: 0.438rem;
  gap: 0.188rem;
  font-size: 0.563rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  color: ${({ $primary }) => $primary};
  background: ${({ $primary }) => `color-mix(in srgb, ${$primary} 15%, transparent)`};
  padding: 0.125rem 0.375rem;
  border-radius: 0.375rem;
`;
